import { fun_PostAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // tab切换的name
      activeName: "1",
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        levelNum: null, // 编号
        level: null, // 等级
        typNum: null, // 资质类型
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "编号：",
          value: "levelNum",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "等级：",
          value: "level",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "select",
          label: "资质类型：",
          value: "typNum",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/BasicDataCombobox",
            zdid: "201507131554050002"
          }
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "编号",
          prop: "levelNum",
        },
        {
          label: "等级",
          prop: "level",
        },
        {
          label: "资质类型",
          prop: "typNumName",
        },
        {
          label: "操作",
          slotName: "operation",
        }
      ],
      // 表格数据
      tableData: [],
      multipleSelection: [], // 勾选数组
      // 请求路径
      reqUrl: "/corpQualificationLevel/list",
    };
  },
  // 接收来自父组件的数据
  props: {

  },
  // 注册组件
  components: {},
  // 模板编译完成
  mounted() {
    // 查询一览数据
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction(this.reqUrl, {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          this.fun_Add();
          break;
        case "修改":
          this.fun_Edit();
          break;
        case "删除":
          this.fun_Del();
          break;
        default:
      }
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 下拉框点击事件
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_Details(e) {
      this.$router.push({path: "/corpQualificationLevelDetail", query: {id:e.id, type: "details", activeName: this.activeName }});
    },
    /**
     * 点击新增按钮
     */
    fun_Add() {
      this.$router.push({path: "/corpQualificationLevelDetail", query: {type: "insert", activeName: this.activeName, }});
    },
    /**
     * 点击修改按钮
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0){
        // 如果勾选超过1条
        if(this.multipleSelection.length > 1){
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        }else{
          this.$router.push({path: "/corpQualificationLevelDetail", query: {id:this.multipleSelection[0].id,type: "update", activeName: this.activeName, }});
        }
      }
    },
    /**
     * 删除
     */
    fun_Del(){
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 主键集合
        let keys = [];
        // 遍历勾选
        for(const index in this.multipleSelection ){
          // 赋值主键集合
          keys[index] = this.multipleSelection[index].id;
        }
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 声明
          var deleteUrl = "/corpQualificationLevel/delete";
          // 判断
          if(this.activeName === "1"){ // 企业资质等级
            // 更换url
            deleteUrl = "/corpQualificationLevel/delete";
          }else if(this.activeName === "2"){ // 企业资质资格序列
            // 更换url
            deleteUrl = "/corpQualificationList/delete";
          }else{ // 企业资质资格专业类别
            // 更换url
            deleteUrl = "/corpTradetypeBound/delete";
          }
          // 请求，获取结果集
          fun_PostAction(deleteUrl, {
            keys: keys
          }).then(res => {
            // 解构res.data
            const { result,msg } = res.data;
            // 判断
            if(result){
              // 操作成功
              this.$message.success(msg);
              // 获取一览表格数据
              this.fun_GetList();
            }else{
              // 提示请求失败消息
              this.$message.error(msg);
            }
          });
        });
      }
      // 如果未进行勾选
      else{
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 企业资质资格需要显示的内容
     */
    fun_GetShowCorpQualificationLevel(){
      // 表头按钮组
      this.btnList = [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ];
      // 查询表单字段
      this.form = {
        levelNum: null, // 编号
        level: null, // 等级
        typNum: null, // 资质类型
      };
      // 查询表单
      this.formSearchList = [
        {
          type: "input",
          label: "编号：",
          value: "levelNum",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "等级：",
          value: "level",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "select",
          label: "资质类型：",
          value: "typNum",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/BasicDataCombobox",
            zdid: "201507131554050002"
          }
        },
      ];
      // 表格基础数据
      this.tableColumns = [
        {
          label: "编号",
          prop: "levelNum",
        },
        {
          label: "等级",
          prop: "level",
        },
        {
          label: "资质类型",
          prop: "typNumName",
        },
        {
          label: "操作",
          slotName: "operation",
        }
      ];
    },
    /**
     * 资质资格序列需要显示的内容
     */
    fun_GetShowCorpQualificationList(){
      // 表头按钮组
      this.btnList = [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ];
      // 查询表单字段
      this.form = {
        certTypeNum: null, // 资质资格类型
        listCode: null, // 编码
        listName: null, // 序列名称
        parentList: null, // 上级序列
      };
      // 查询表单
      this.formSearchList = [
        {
          type: "select",
          label: "资质资格类型：",
          value: "certTypeNum",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/BasicDataCombobox",
            zdid: "201507131554050002"
          }
        },
        {
          type: "input",
          label: "编码：",
          value: "listCode",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "序列名称：",
          value: "listName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "上级序列：",
          value: "parentList",
          placeholder: "请输入",
          clearable: true
        },
      ];
      // 表格基础数据
      this.tableColumns = [
        {
          label: "资质资格类型",
          prop: "certTypeName",
        },
        {
          label: "编码",
          prop: "listCode",
        },
        {
          label: "序列名称",
          prop: "listName",
        },
        {
          label: "上级序列",
          prop: "parentList",
        },
        {
          label: "综合标志",
          prop: "overAllFlagName",
        },
        {
          label: "操作",
          slotName: "operation",
        }
      ];
    },
    /**
     * 资质资格专业需要显示的内容
     */
    fun_GetShowCorpTradetypeBound(){
      // 表头按钮组
      this.btnList = [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ];
      // 查询表单字段
      this.form = {
        tradeLargeClassName: null, // 专业大类名称
        tradeLargeClass: null, // 专业大类
        tradeCategoryCode: null, // 专业小类编码
        tradeCategoryName: null, // 专业小类名称
      };
      // 查询表单
      this.formSearchList = [
        {
          type: "input",
          label: "专业大类：",
          value: "tradeLargeClassName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "专业小类编码：",
          value: "tradeCategoryCode",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "专业小类名称：",
          value: "tradeCategoryName",
          placeholder: "请输入",
          clearable: true
        },
      ];
      // 表格基础数据
      this.tableColumns = [
        {
          label: "专业大类",
          prop: "tradeLargeClassName",
        },
        {
          label: "专业小类编码",
          prop: "tradeCategoryCode",
        },
        {
          label: "专业小类名称",
          prop: "tradeCategoryName",
        },
        {
          label: "操作",
          slotName: "operation",
        }
      ];
    },
    /**
     * @description 切换tabs
     * @author
     */
     fun_HandleClick(tab, event) {
      // 切换标签页
      this.activeName = tab.name;
      // 如果是企业资质资格
      if (tab.name === "1") {
        // 显示企业资质资格
        this.fun_GetShowCorpQualificationLevel();
        // 更换请求路径
        this.reqUrl = "/corpQualificationLevel/list";
      } else if(tab.name === "2") {
        // 显示资质资格序列
        this.fun_GetShowCorpQualificationList();
        // 更换请求路径
        this.reqUrl = "/corpQualificationList/list";
      }else{
        // 显示资质资格专业
        this.fun_GetShowCorpTradetypeBound();
        // 更换请求路径
        this.reqUrl = "/corpTradetypeBound/list";
      }
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
  }
};
